export default __webpack_public_path__ + "static/logo_120-a8ce016ca88f602ef0acc02b6f0bbff4.png";